/**
 ################################
 * Component geeg_stickynav
 * Built with Maciste / Version 2.0
 ################################
 */


'use strict';

jQuery(document).ready(function ($) {
  var stickynav = $('.geeg_stickynav');
  // var bg = stickynav[0].getAttribute('data-bg');
  //var scroll_in = stickynav[0].getAttribute('data-in');
  //stickynav.hide();
  $(function () {
    var hasBeenTrigged = false;
    $(window).scroll(function (e) {
      e.preventDefault();

      if ($(this).scrollTop() > '100' && !hasBeenTrigged) { // if scroll is greater/equal then 100 and hasBeenTrigged is set to false.
        stickynav.addClass('geeg_stickynav--sticky');
        stickynav.fadeIn('fast', function () {
          // Animation complete.
        });
      } else {
        stickynav.removeClass('geeg_stickynav--sticky');
        stickynav.fadeOut('fast', function () {
          // Animation complete.
        });

      }
    });
  });


// return array of [r,g,b,a] from any valid color. if failed returns undefined
  function colorValues(color)
  {
    if (!color)
      return;
    if (color.toLowerCase() === 'transparent')
      return [0, 0, 0, 0];
    if (color[0] === '#')
    {
      if (color.length < 7)
      {
        // convert #RGB and #RGBA to #RRGGBB and #RRGGBBAA
        color = '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : '');
      }
      return [parseInt(color.substr(1, 2), 16),
        parseInt(color.substr(3, 2), 16),
        parseInt(color.substr(5, 2), 16),
        color.length > 7 ? parseInt(color.substr(7, 2), 16)/255 : 1];
    }
    if (color.indexOf('rgb') === -1)
    {
      // convert named colors
      var temp_elem = document.body.appendChild(document.createElement('fictum')); // intentionally use unknown tag to lower chances of css rule override with !important
      var flag = 'rgb(1, 2, 3)'; // this flag tested on chrome 59, ff 53, ie9, ie10, ie11, edge 14
      temp_elem.style.color = flag;
      if (temp_elem.style.color !== flag)
        return; // color set failed - some monstrous css rule is probably taking over the color of our object
      temp_elem.style.color = color;
      if (temp_elem.style.color === flag || temp_elem.style.color === '')
        return; // color parse failed
      color = getComputedStyle(temp_elem).color;
      document.body.removeChild(temp_elem);
    }
    if (color.indexOf('rgb') === 0)
    {
      if (color.indexOf('rgba') === -1)
        color += ',1'; // convert 'rgb(R,G,B)' to 'rgb(R,G,B)A' which looks awful but will pass the regxep below
      return color.match(/[\.\d]+/g).map(function (a)
      {
        return +a
      });
    }
  }

  /*
 Examples:

     colorValues('transparent'); // [0,0,0,0]
     colorValues('white'); // [255, 255, 255, 1]
     colorValues('teal'); // [0, 128, 128, 1]
     colorValues('rgba(11,22,33,.44)'); // [11, 22, 33, 0.44]
     colorValues('rgb(11,22,33)'); // [11, 22, 33, 1]
     colorValues('#abc'); // [170, 187, 204, 1]
     colorValues('#abc6'); // [170, 187, 204, 0.4]
     colorValues('#aabbcc'); // [170, 187, 204, 1]
     colorValues('#aabbcc66'); // [170, 187, 204, 0.4]
     colorValues('asdf'); // undefined
     colorValues(''); // undefined
     colorValues(NaN); // Script Error
     colorValues(123); // Script Error
 *!/*/


/*

  var blur = stickynav[0].getAttribute('data-blur');

  if (blur == 1) {
    const element = document.querySelector('.geeg_stickynav')


    const style = getComputedStyle(element)

    const backgroundColor = style.backgroundColor
    const rgbaBg = colorValues(backgroundColor);
    element.style.backgroundColor = 'rgba('+ rgbaBg[0]+ ',' + rgbaBg[1] +',' +rgbaBg[2]+',"0.9")'

    console.log() // rgb(0, 0, 0)

    stickynav.addClass('geeg_stickynav--blur')
    stickynav.removeClass('bg-dark')

    var bgClass = document.querySelector('div[class*="bg-"]');
    for (let i = bgClass.classList.length - 1; i >= 0; i--) {
      const className = bgClass.classList[i];
      if (className.startsWith('ativo')) {
        bgClass.classList.remove(className);
      }
    }


  }
*/

});

